import { useState, useEffect } from 'react';
import { fetchAboutContent } from './aboutApi';
import { AboutData } from './types';

export const useGetAboutContent = () => {
  const [aboutData, setAboutData] = useState<AboutData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await fetchAboutContent();

        if (response.status === 200) {
          setAboutData(response.data);
        } else {
          setError('Failed to load about content');
        }
      } catch (err) {
        setError('Error loading about content');
        console.error('About content loading error:', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadContent();
  }, []);

  return { aboutData, isLoading, error };
};
